"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_slider_1 = __importDefault(require("react-slider"));
var error_message_1 = __importDefault(require("../components/error-message"));
var styling_1 = require("./styling");
var PatternCard = function (_a) {
    var item = _a.item, selected = _a.selected, disabled = _a.disabled, onClick = _a.onClick, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('position-relative', className), style: { userSelect: 'none', opacity: disabled ? 0.5 : undefined } },
        react_1.default.createElement("div", { className: 'height-100', style: { display: 'grid', gridTemplateRows: 'min-content auto', gridTemplateColumns: '1fr' }, onClick: onClick },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('overflow-hidden rounded-lg', selected ? 'border-wisteria' : 'border-brownish-grey', !disabled ? 'cursor-pointer' : ''), style: { gridArea: '1 / 1 / 2 / 2', aspectRatio: '1/1', borderWidth: selected ? 3 : 1, borderStyle: 'solid' } }, item.image.src && (react_1.default.createElement("img", { className: 'height-100 width-100 object-fit-cover', src: item.image.src, alt: item.image.alt, draggable: false, style: { pointerEvents: 'none', userSelect: 'none' } }))))));
};
/** @todo should probably stop using react-hook-form in this component and just use state instead. */
var WeightAndPatternGenders = function (_a) {
    var NavBar = _a.NavBar, initialStepFormData = _a.initialStepFormData, setStepFormDataAndSubmit = _a.setStepFormDataAndSubmit, selectedPatternKeys = _a.selectedPatternKeys, setSelectedPatternKeys = _a.setSelectedPatternKeys, availablePatterns = _a.availablePatterns, babyFirstName = _a.babyFirstName;
    var weightOptions = [
        { displayName: 'Set weight', value: undefined },
        { displayName: 'Up to 8 lbs', value: '8_and_under_lbs' },
        { displayName: '8 to 10 lbs', value: '8_10_lbs' },
        { displayName: '10 to 14 lbs', value: '10_14_lbs' },
        { displayName: '14 to 18 lbs', value: '14_18_lbs' },
        { displayName: '18 to 22 lbs', value: '18_22_lbs' },
        { displayName: '22 to 27 lbs', value: '22_27_lbs' },
        { displayName: '32 to 35 lbs', value: '32_35_lbs' },
        { displayName: '35 to 38 lbs', value: '35_38_lbs' },
        { displayName: '38+ lbs', value: '38_plus_lbs' },
    ];
    var weightIndexInitialValue = weightOptions.findIndex(function (option) { return option.value === initialStepFormData.babyWeight; });
    if (weightIndexInitialValue === -1)
        weightIndexInitialValue = 0;
    var defaultValues = { weightIndex: weightIndexInitialValue };
    var _b = (0, react_hook_form_1.useForm)({ defaultValues: defaultValues, mode: 'onChange' }), handleSubmit = _b.handleSubmit, formState = _b.formState, control = _b.control;
    var _c = __read((0, react_1.useState)(), 2), patternGendersErrorMessage = _c[0], setPatternGendersErrorMessage = _c[1];
    var MIN_PATTERNS_TO_SELECT = 0;
    var MAX_PATTERNS_TO_SELECT = 3;
    var nextButtonEnabled = selectedPatternKeys.size >= MIN_PATTERNS_TO_SELECT && formState.isValid;
    // This component is sort of a gross mix of state managed by react-hook-form and state managed by useState calls.
    // When submitting, we use a combination of both to build the final state with which to call setStepFormData.
    var onSubmit = function (data) {
        var e_1, _a;
        var newPrefs = [];
        try {
            for (var availablePatterns_1 = __values(availablePatterns), availablePatterns_1_1 = availablePatterns_1.next(); !availablePatterns_1_1.done; availablePatterns_1_1 = availablePatterns_1.next()) {
                var item = availablePatterns_1_1.value;
                if (selectedPatternKeys.has(item.key)) {
                    newPrefs.push(item.gender);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (availablePatterns_1_1 && !availablePatterns_1_1.done && (_a = availablePatterns_1.return)) _a.call(availablePatterns_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Should never get here because we disable the next button when there are not enough patterns selected.
        if (newPrefs.length < MIN_PATTERNS_TO_SELECT) {
            var message = "Please select at least ".concat(MIN_PATTERNS_TO_SELECT, " patterns");
            throw new Error(message);
        }
        setStepFormDataAndSubmit({ preferredPatternGenders: __spreadArray([], __read(newPrefs), false), babyWeight: weightOptions[data.weightIndex].value });
    };
    var beforeGoNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canGoNext, onError, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    canGoNext = true;
                    onError = function () {
                        canGoNext = false;
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleSubmit(onSubmit, onError)()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    // handleSubmit does not seem to catch errors thrown by the onSubmit function and pass them to onError, so we catch them here
                    setPatternGendersErrorMessage(error_1.message);
                    canGoNext = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, canGoNext];
            }
        });
    }); };
    var togglePatternKey = function (key) {
        setSelectedPatternKeys(function (prefs) {
            var newSelectedKeys = new Set(prefs);
            if (newSelectedKeys.has(key)) {
                newSelectedKeys.delete(key);
            }
            else {
                if (prefs.size >= MAX_PATTERNS_TO_SELECT)
                    return newSelectedKeys;
                newSelectedKeys.add(key);
            }
            return newSelectedKeys;
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'h-8' }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("form", { className: styling_1.formClassName },
                react_1.default.createElement("div", { className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName },
                            "How much does ",
                            babyFirstName ? babyFirstName : 'your baby',
                            " weigh?"),
                        react_1.default.createElement("div", { className: styling_1.fieldSubheadingClassName }, "(So we know what size to recommend. Not cuz we\u2019re judgy.)")),
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'weightIndex', render: function (_a) {
                            var onChange = _a.onChange, value = _a.value;
                            return (react_1.default.createElement(react_slider_1.default, { className: 'flex-container items-center h-8', thumbClassName: 'height-100 w-20 flex-container flex-dir-column justify-between', trackClassName: 'h-2 pt-4 bg-light-purple rounded', marks: 1, min: 0, max: weightOptions.length - 1, value: value, onChange: onChange, 
                                // withTracks
                                renderThumb: function (props, state) {
                                    return (react_1.default.createElement("div", __assign({}, props),
                                        react_1.default.createElement("div", { className: (0, classnames_1.default)('width-100 height-100 cursor-pointer square rounded-full flex-container items-center justify-center', state.valueNow === 0 ? 'bg-light-wisteria' : 'bg-wisteria') },
                                            react_1.default.createElement("div", { className: 'text-xs width-100 text-white justify-center flex-container' }, weightOptions[state.valueNow].displayName))));
                                } }));
                        } })),
                react_1.default.createElement("div", { className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName }, "What\u2019s your style?"),
                        react_1.default.createElement("div", { className: styling_1.fieldSubheadingClassName }, "(Just for the vibes. You\u2019ll still get to pick from all designs.)")),
                    react_1.default.createElement("div", { className: 'quiz-diaper-bundle-patterns--pattern-card-grid' }, availablePatterns.map(function (item) {
                        var selected = !!selectedPatternKeys.has(item.key);
                        var disabled = !selected && selectedPatternKeys.size >= MAX_PATTERNS_TO_SELECT;
                        return react_1.default.createElement(PatternCard, { key: item.key, item: item, selected: selected, disabled: disabled, onClick: function () { return togglePatternKey(item.key); } });
                    })),
                    react_1.default.createElement(error_message_1.default, { error: patternGendersErrorMessage ? { message: patternGendersErrorMessage } : undefined })))),
        react_1.default.createElement(NavBar, { backButtonEnabled: true, nextButtonEnabled: nextButtonEnabled, beforeGoNext: beforeGoNext })));
};
exports.default = WeightAndPatternGenders;
